import React from 'react'
import useElapsedAnimationFrames from '../hooks/useElapsedAnimationFrames'

const DelayedRender = ({ frames, children }) => {
  const shouldRender = useElapsedAnimationFrames(frames)

  return shouldRender ? <>{children}</> : null
}

export default DelayedRender
